export default __webpack_public_path__ + "static/media/sw_7.8196dec1.png";